import React, { useState, useEffect } from "react";
import { Formik, Field, Form, FieldArray } from "formik";
import * as LS from "../../../styles/LearnerStyled";
import * as CDD from "../../../styles/CourseDetStyled";
import * as CDS from "../../../styles/CourseDetailStyled";
import * as SEC from "../../../styles/SectionStyled";
import * as UE from "../../../styles/UserElement";
import editIcon from "../../../assets/images/editLight.png";
import lighRight from "../../../assets/images/lighRight.png";
import lightLeft from "../../../assets/images/lightLeft.png";
import darkArrow from "../../../assets/images/darkArrow.png";
import darkRight from "../../../assets/images/darkRight.png";
import dotImage from "../../../assets/images/dotImage.png";
import * as CS from "../../../styles/CommonStyled";
import Modal from "../../../components/Modal/Modal";
import successModal from "../../../assets/images/successModal.png";
import { Table } from "antd";
import {
  clientValidator,
  clientCourseValidator,
  learnerClientValidator,
  policyClientValidator,
  ClientBillingValidator,
  URLValidator,
} from "../../../utils/validator";
import darkCheckboxBaseIcon from "../../../assets/images/dark_base.png";
import darkcheckIcon from "../../../assets/images/darkcheckIcon.png";
import checkboxIcon from "../../../assets/images/Checkbox.png";
import checkboxBaseIcon from "../../../assets/images/_Checkbox_base.png";
import Input from "../../../components/Inputs/InputAdd";
import PageSelect from "../../../components/PageSelect";
import Switch from "../../../components/Switch/Switch";
import plsuIcon from "../../../assets/images/plsuIcon.png";
import SampleExcel from "../../../assets/images/Learners.xlsx";
import downloadIcon from "../../../assets/images/downloadIcon.png";
import UploadTrailer from "../../../components/UploadTrailer";
import darkUploadIcon from "../../../assets/images/darkUploadIcon.png";
import upIcon from "../../../assets/images/upIcon.png";
import {
  combineDateAndTime,
  countryValidationData,
  formatFileSize,
} from "../../../utils/Helpers";
import csvIcon from "../../../assets/images/csvIcon.png";
import delIcon from "../../../assets/images/delete.png";
import orangeDownloadIcon from "../../../assets/images/orangeDownloadIcon.png";
import CourseView from "./CourseViewBackup";
import { Course, Learner } from "../../../utils/api";
import axios from "../../../utils/axios";
import { useSelector, useDispatch } from "react-redux";
import { setErrorPop, setErrorPopMsg } from "../../../store/action";
import InputMobile from "../../../components/InputMobile";
import { PopUp } from "../../../components/PopUp/PopUp";
import MultiSelect from "../../../components/MultiSelect";
import warnsIcon from "../../../assets/images/warns.png";

const AddLearner = ({ theme, navigate, localState, dispatch }) => {
  const [showsucessMail, setShowsucessMail] = useState(false);
  const [warningPopUp, setWarningPopUp] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  // const [learnerInitialValues, setLearnerInitialValues] = useState({
  //   data: [
  //     {
  //       name: "",
  //       email: "",
  //       mobileNumber: "",
  //       mobileNumberCountryCode: "+91",
  //       department: "",
  //       reportingManager: "",
  //       city: "",
  //       designation: "",
  //       subEntity: "",
  //       activate: false,
  //     },
  //   ],
  //   isAdd: true,
  //   isUpload: false,
  //   isTable: false,
  //   isTableSingle: false,
  //   fileName: "",
  //   fileSize: "",
  //   fileUrl: "",
  // });
  const [learnerInitialValues, setLearnerInitialValues] = useState({
    data: [
      {
        name: "",
        email: "",
        mobileNumber: "",
        mobileNumberCountryCode: "",
        department: "",
        reportingManager: "",
        city: "",
        designation: "",
        subEntity: "",
        clientLearnerId: "",
        activate: false,
        email_dnd: true,
      },
    ],
    table_data: [
      {
        name: "",
        email: "",
        mobileNumber: "",
        mobileNumberCountryCode: "",
        department: "",
        reportingManager: "",
        city: "",
        designation: "",
        subEntity: "",
        activate: false,
        email_dnd: true,
      },
    ],
    backup_data: [
      {
        name: "",
        email: "",
        mobileNumber: "",
        mobileNumberCountryCode: "",
        department: "",
        reportingManager: "",
        city: "",
        designation: "",
        subEntity: "",
        activate: false,
        email_dnd: true,
      },
    ],
    singlename: "",
    singleemail: "",
    singlemobileNumber: "",
    singlemobileNumberCountryCode: "",
    singledepartment: "",
    singlereportingManager: "",
    singlecity: "",
    singledesignation: "",
    singlesubEntity: "",
    singleactivate: false,
    singleIndex: null,
    isAdd: true,
    isUpload: false,
    isTable: false,
    isTableSingle: false,
    fileName: "",
    fileSize: "",
    fileUrl: "",
    languageId: [],
  });

  const courseId = useSelector((state) => state?.courseId);
  const clientId = useSelector((state) => state?.clientId);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCountLearner, setTotalCountLearner] = useState(0);

  const pageLimit = 10;
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const selectLangJson = useSelector((state) => state?.selectLangJson);
  const languageData = useSelector((state) => state?.languageData) || [];
  const [downloadLoadingTwo, setDownloadLoadingTwo] = useState(false);
  const [languageListo, setLanguageListo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorObj, setErrorObj] = useState({});
  const [totalCount, setTotalCount] = useState(0);

  console.log(languageData, "languageDatalanguageDatalanguageDatalanguageData");

  const handleExcel = async (e) => {
    let url =
      "https://vc.rainmaker.co.in/api/v2/admin/private/clientLearner/excel/upload/";
    const formData = new FormData();
    formData.append("excelFile", e);
    // console.log(e);
    const config = { headers: { "Content-Type": "multipart/form-data" } };
    try {
      const { data } = await axios.post(url, formData, config);
      // setIsLoadingUpload(false);
      return data;
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const handleLearner = async (values) => {
    setIsLoading(true);
    console.log(values, "values");
    let url = Course.learnerAdd;
    var formData = {
      data: values?.data?.map((val) => {
        const obj = {
          userName: val.name?.trim(""), // Assuming name is always present
          clientLearnerId: val.clientLearnerId, // Assuming name is always present
          active: val.activate ? 1 : 0,
          clientId: clientId,
          clientCourseId: courseId,
          languages: values?.languageId?.map((val) => val.value),
          email_dnd: val.email_dnd,
        };

        // Conditionally add properties if they are not empty or undefined
        if (val.email) obj.email = val.email?.trim("");
        if (val.mobileNumber) obj.mobileNumber = val.mobileNumber.toString();
        if (val.mobileNumberCountryCode)
          obj.mobileNumberCountryCode = val.mobileNumberCountryCode;
        if (val.department) obj.department = val.department;
        if (val.reportingManager) obj.reportingManager = val.reportingManager;
        if (val.city) obj.city = val.city;
        if (val.designation) obj.designation = val.designation;
        if (val.subEntity) obj.subEntity = val.subEntity;

        return obj;
      }),
    };
    var formDataBulk = {
      data: values?.table_data?.map((val) => {
        const obj = {
          userName: val.name?.trim(""), // Assuming name is always present
          active: val.activate ? 1 : 0,
          clientId: clientId,
          clientCourseId: courseId,
          clientLearnerId: val.clientLearnerId,
          email_dnd:val.email_dnd
        };

        // Conditionally add properties if they are not empty or undefined
        if (val.email) obj.email = val.email?.trim("");
        if (val.mobileNumber) obj.mobileNumber = val.mobileNumber.toString();
        if (val.mobileNumberCountryCode)
          obj.mobileNumberCountryCode = val.mobileNumberCountryCode;
        if (val.department) obj.department = val.department;
        if (val.reportingManager) obj.reportingManager = val.reportingManager;
        if (val.city) obj.city = val.city;
        if (val.designation) obj.designation = val.designation;
        if (val.subEntity) obj.subEntity = val.subEntity;

        return obj;
      }),
    };
    try {
      const { data } = await axios.post(
        url,
        values?.isTable ? formDataBulk : formData
      );
      console.log(data);
      setIsLoading(false);
      setShowsucessMail(true);
      setTimeout(() => {
        setShowsucessMail(false);
        navigate("/client-admin/courses-manage/manage-learners");
      }, 2000);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response.data.message);
      if (error.response && error.response.status === 400) {
        // dispatch(setErrorPop(true));
        setWarningPopUp(true);
        setWarningMessage(error?.response?.data);
        // console.log(error.response.data.message, "sachin6757@gmail.com");
        // dispatch(setErrorPopMsg(error?.response?.data?.message));
      }
      let errObj = {};
      error.response.data.errors?.map((val) => {
        console.log(val.path, "error val");
        if (!errObj[val.path]) {
          errObj[val.path] = val.msg;
        }
      });
      setErrorObj(errObj);
    }
  };
  const pageLimitLearner = 10;
  const handleClose = () => {
    setShowsucessMail(false);
  };

  console.log(warningMessage, "warningMessage warningMessage");
  const numberOfPages = Math.ceil(totalCountLearner / pageLimitLearner);

  const downloadCertificate = async (e) => {
    setDownloadLoadingTwo(true);
    try {
      let url = `${Course.learnerReport}${e}`;
      const { data } = await axios({
        url: url,
        method: "GET",
        responseType: "blob", // Important: set response type as blob for binary data
      });
      const blob = new Blob([data], { type: "application/pdf" });

      // Create a link element, set the download attribute and trigger a click
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "downloaded_file.xlsx"; // Set the name of the downloaded file
      document.body.appendChild(link);
      link.click();

      setDownloadLoadingTwo(false);
      setWarningPopUp(false);
      // Clean up and remove the link element
      link.parentNode.removeChild(link);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        dispatch(setErrorPop(true));
        dispatch(setErrorPopMsg(error?.response?.data?.message));
      }
      setDownloadLoadingTwo(false);
      console.log(error.response.data.message);
    }
  };

  useEffect(() => {
    console.log("setp 1");
    if (languageData?.length > 0) {
      console.log("setp 2");
      const langOptions = languageData?.map((val) => {
        return {
          label: val.title,
          value: val._id,
        };
      });
      console.log("setp ");
      setLanguageListo(langOptions);
    }
  }, [languageData]);
  return (
    <CDS.DetailContainer>
      {/* <CourseView theme={theme} localState={localState} /> */}
      <CDS.DetailCon>
        <CDS.DetailInnerCon>
          <LS.LearnerBox>
            <Formik
              enableReinitialize
              initialValues={learnerInitialValues}
              validate={learnerClientValidator}
              validateOnChange
              onSubmit={(values) => handleLearner(values, false)}
            >
              {(formikBag) => (
                <Form style={{ width: "100%" }}>
                  <UE.FormContainer style={{ padding: 0 }} themeColor={theme}>
                    <UE.FormTitle style={{ marginTop: "0" }} themeColor={theme}>
                      {selectLangJson.add_learner}
                    </UE.FormTitle>
                    <UE.FormContainerBorder
                      themeColor={theme}
                      style={{
                        padding: "0.8rem 0.7rem 0.8rem 1rem",
                        marginTop: "1rem",
                        marginBottom: "1rem",
                      }}
                    >
                      <UE.InputBoxContainers
                        style={{
                          justifyContent: "flex-start",
                          // marginTop: "0.7rem",
                        }}
                      >
                        <UE.ComFeedbackRowss>
                          <UE.CheckBoxs
                            onClick={() => {
                              formikBag.setFieldValue(`isAdd`, true);
                              formikBag.setFieldValue(`isUpload`, false);
                            }}
                          >
                            <img
                              src={
                                formikBag.values.isAdd
                                  ? theme
                                    ? darkcheckIcon
                                    : checkboxIcon
                                  : theme
                                  ? darkCheckboxBaseIcon
                                  : checkboxBaseIcon
                              }
                              alt=""
                            />
                          </UE.CheckBoxs>
                          <UE.FeedbackOrangeTextUpl>
                            {selectLangJson.add_manually}
                          </UE.FeedbackOrangeTextUpl>
                        </UE.ComFeedbackRowss>
                        <UE.ComFeedbackRowss>
                          <UE.CheckBoxs
                            onClick={() => {
                              formikBag.setFieldValue(`isUpload`, true);
                              formikBag.setFieldValue(`isAdd`, false);
                            }}
                          >
                            <img
                              src={
                                formikBag.values.isUpload
                                  ? theme
                                    ? darkcheckIcon
                                    : checkboxIcon
                                  : theme
                                  ? darkCheckboxBaseIcon
                                  : checkboxBaseIcon
                              }
                              alt=""
                            />
                          </UE.CheckBoxs>
                          <UE.FeedbackOrangeTextUpl>
                            {selectLangJson.upload}
                          </UE.FeedbackOrangeTextUpl>
                        </UE.ComFeedbackRowss>
                      </UE.InputBoxContainers>
                    </UE.FormContainerBorder>
                    <UE.InputBoxContainers>
                      <UE.InputBox wiDth={"49%"}>
                        <Field name="languageId">
                          {({ field }) => (
                            <MultiSelect
                              {...field}
                              isSelectAll={true}
                              menuPlacement={"bottom"}
                              options={languageListo}
                              label={selectLangJson.languages}
                              star={true}
                              onChange={(e) => {
                                formikBag.setFieldValue("languageId", e);
                                formikBag.setFieldTouched(
                                  "languageId",
                                  true,
                                  false
                                );
                                errorObj.languageIds = "";
                              }}
                              onBlur={() =>
                                formikBag.setFieldTouched("languageId", true)
                              }
                              // isMulti
                              value={formikBag.values.languageId}
                              placeholder={selectLangJson?.select_language}
                              error={
                                formikBag.touched.languageId &&
                                formikBag.errors.languageId
                                  ? formikBag.errors.languageId
                                  : null
                              }
                              erroros={errorObj.languages}
                            />
                          )}
                        </Field>
                      </UE.InputBox>
                    </UE.InputBoxContainers>
                    {formikBag.values.isAdd ? (
                      <FieldArray name="data">
                        {({
                          insert,
                          remove: learnerRemove,
                          push: learnerPush,
                        }) => {
                          return (
                            <UE.FormContainer
                              themeColor={theme}
                              style={{
                                padding: "0",
                                margin: 0,
                              }}
                            >
                              {formikBag.values?.data?.length > 0 &&
                                formikBag.values?.data?.map((val, ind) => {
                                  return (
                                    <>
                                      <UE.FormContainerBorder
                                        themeColor={theme}
                                        style={{
                                          padding: "1rem",
                                        }}
                                      >
                                        <UE.InputBoxContainer>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field name={`data[${ind}].name`}>
                                              {({ field, form, meta }) => (
                                                <Input
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson.learner_name
                                                  }
                                                  label={
                                                    selectLangJson.learner_name
                                                  }
                                                  onChange={form.handleChange}
                                                  star={true}
                                                  theme={theme}
                                                  onBlur={form.handleBlur}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].userName`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field name={`data[${ind}].email`}>
                                              {({ field, form, meta }) => (
                                                <Input
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson.learner_email
                                                  }
                                                  label={
                                                    selectLangJson.learner_email
                                                  }
                                                  theme={theme}
                                                  onChange={form.handleChange}
                                                  star={true}
                                                  onBlur={form.handleBlur}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].email`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field
                                              name={`data[${ind}].clientLearnerId`}
                                            >
                                              {({ field, form, meta }) => (
                                                <Input
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson.employee_id
                                                  }
                                                  label={
                                                    selectLangJson.employee_id
                                                  }
                                                  theme={theme}
                                                  onChange={form.handleChange}
                                                  star={false}
                                                  onBlur={form.handleBlur}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].clientLearnerId`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field
                                              name={`data[${ind}].mobileNumber`}
                                            >
                                              {({ field, form, meta }) => (
                                                <InputMobile
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson?.mobile_number
                                                  }
                                                  label={
                                                    selectLangJson?.mobile_number
                                                  }
                                                  icon={true}
                                                  type="number"
                                                  value={
                                                    val.mobileNumberCountryCode +
                                                    val.mobileNumber
                                                  }
                                                  onChange={(phone, data) => {
                                                    formikBag.setFieldValue(
                                                      `data[${ind}].mobileNumberCountryCode`,
                                                      data.format.slice(0, 1) +
                                                        data.dialCode
                                                    );
                                                    formikBag.setFieldValue(
                                                      `data[${ind}].mobileNumber`,
                                                      phone.slice(
                                                        data.dialCode.length
                                                      )
                                                    );
                                                  }}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].mobileNumber`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field
                                              name={`data[${ind}].department`}
                                            >
                                              {({ field, form, meta }) => (
                                                <Input
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson.department
                                                  }
                                                  label={
                                                    selectLangJson.department
                                                  }
                                                  onChange={form.handleChange}
                                                  onBlur={form.handleBlur}
                                                  theme={theme}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].department`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field
                                              name={`data[${ind}].reportingManager`}
                                            >
                                              {({ field, form, meta }) => (
                                                <Input
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson.reporting_manager
                                                  }
                                                  label={
                                                    selectLangJson.reporting_manager
                                                  }
                                                  theme={theme}
                                                  onChange={form.handleChange}
                                                  onBlur={form.handleBlur}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].reportingManager`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field name={`data[${ind}].city`}>
                                              {({ field, form, meta }) => (
                                                <Input
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson.enter_city
                                                  }
                                                  label={
                                                    selectLangJson.enter_city
                                                  }
                                                  theme={theme}
                                                  onChange={form.handleChange}
                                                  onBlur={form.handleBlur}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].city`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field
                                              name={`data[${ind}].designation`}
                                            >
                                              {({ field, form, meta }) => (
                                                <Input
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson.designation
                                                  }
                                                  label={
                                                    selectLangJson.designation
                                                  }
                                                  theme={theme}
                                                  onChange={form.handleChange}
                                                  onBlur={form.handleBlur}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].designation`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                          <UE.InputBox wiDth={"49%"}>
                                            <Field
                                              name={`data[${ind}].subEntity`}
                                            >
                                              {({ field, form, meta }) => (
                                                <Input
                                                  {...field}
                                                  placeholder={
                                                    selectLangJson.sub_entity
                                                  }
                                                  theme={theme}
                                                  label={
                                                    selectLangJson?.sub_entity
                                                  }
                                                  onChange={form.handleChange}
                                                  onBlur={form.handleBlur}
                                                  error={
                                                    meta.touched && meta.error
                                                      ? meta.error
                                                      : null
                                                  }
                                                  erroros={
                                                    errorObj[
                                                      `data[${ind}].subEntity`
                                                    ]
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </UE.InputBox>
                                        </UE.InputBoxContainer>

                                        <UE.DefaultBox>
                                          <UE.DefaultText themeColor={theme}>
                                            {selectLangJson.active_inactive} :
                                          </UE.DefaultText>
                                          <UE.DefaultToggle>
                                            <Switch
                                              rounded={true}
                                              isToggled={val.activate}
                                              bgColorChecked="#F6591C"
                                              roundColorChecked="#ffffff"
                                              border={
                                                theme
                                                  ? "1px solid transparent"
                                                  : "1px solid #D7DAE0"
                                              }
                                              bgColorUnChecked={
                                                theme ? "#1F242F" : "#D7DAE0"
                                              }
                                              themeColor={theme}
                                              roundColorUnChecked="#ffffff"
                                              onToggle={() => {
                                                formikBag.setFieldValue(
                                                  `data[${ind}].activate`,
                                                  !val.activate
                                                );
                                                // setIsToggled(!isToggled)
                                              }}
                                            />
                                          </UE.DefaultToggle>
                                        </UE.DefaultBox>
                                        <UE.DefaultBox>
                                          <UE.DefaultText themeColor={theme}>
                                            {selectLangJson.trigger_mail} :
                                          </UE.DefaultText>
                                          <UE.DefaultToggle>
                                            <Switch
                                              rounded={true}
                                              isToggled={val.email_dnd}
                                              bgColorChecked="#F6591C"
                                              roundColorChecked="#ffffff"
                                              border={
                                                theme
                                                  ? "1px solid transparent"
                                                  : "1px solid #D7DAE0"
                                              }
                                              bgColorUnChecked={
                                                theme ? "#1F242F" : "#D7DAE0"
                                              }
                                              themeColor={theme}
                                              roundColorUnChecked="#ffffff"
                                              onToggle={() => {
                                                formikBag.setFieldValue(
                                                  `data[${ind}].email_dnd`,
                                                  !val.email_dnd
                                                );
                                                // setIsToggled(!isToggled)
                                              }}
                                            />
                                          </UE.DefaultToggle>
                                        </UE.DefaultBox>
                                      </UE.FormContainerBorder>
                                      {formikBag.values?.data?.length > 1 ? (
                                        <UE.AddQuizs
                                          style={{
                                            justifyContent: "right",
                                            marginTop: 0,
                                            marginBottom: "1rem",
                                          }}
                                          onClick={() => learnerRemove(ind)}
                                        >
                                          {selectLangJson.delete}
                                        </UE.AddQuizs>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  );
                                })}
                              <UE.OrangeButtonText
                                onClick={() => {
                                  learnerPush({
                                    name: "",
                                    email: "",
                                    mobileNumber: "",
                                    department: "",
                                    reportingManager: "",
                                    mobileNumberCountryCode: "",
                                    city: "",
                                    designation: "",
                                    subEntity: "",
                                    activate: false,
                                    email_dnd: false,
                                  });
                                }}
                              >
                                <img
                                  src={plsuIcon}
                                  style={{
                                    marginRight: "10px",
                                  }}
                                  alt=""
                                />
                                {selectLangJson.add_new}
                              </UE.OrangeButtonText>
                            </UE.FormContainer>
                          );
                        }}
                      </FieldArray>
                    ) : (
                      ""
                    )}
                    {formikBag.values.isUpload ? (
                      <>
                        <UE.FormContainer
                          style={{ padding: 0 }}
                          themeColor={theme}
                        >
                          <UE.RowTitle>
                            <UE.InputLabless themeColor={theme}>
                              {selectLangJson.upload_learners}
                              <span
                                style={{
                                  color: "#F6591C",
                                }}
                              >
                                *
                              </span>
                            </UE.InputLabless>
                            <LS.OrangeTemplate href={SampleExcel} download>
                              <img src={orangeDownloadIcon} alt="" />{" "}
                              {selectLangJson.download_template}
                            </LS.OrangeTemplate>
                          </UE.RowTitle>
                          <UploadTrailer
                            type="file"
                            id="pic"
                            theme={theme}
                            // label="Upload Translations"
                            upIcon={theme ? darkUploadIcon : upIcon}
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            accepTed="text/csv"
                            other="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            others="application/vnd.ms-excel"
                            alertMsg="No XLS Found"
                            description="XLS (Max. 100 MB)"
                            // star={true}
                            onChange={async (e) => {
                              const fileSize =
                                e.target.files[0].size / 1024 / 1024; // in MiB
                              if (fileSize > 100) {
                                alert("Each file must be 100MB or less");
                                // $(file).val(''); //for clearing with Jquery
                              } else {
                                const file = e.target.files[0];

                                // Function to check if the file is CSV or Excel
                                const isCsvOrExcel = (file) => {
                                  return (
                                    file?.type ===
                                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                                    file?.type === "application/vnd.ms-excel"
                                  );
                                };

                                if (!isCsvOrExcel(file)) {
                                  alert("No XLS file found");
                                } else {
                                  setIsLoadingUpload(true);
                                  formikBag.setFieldValue(
                                    `fileName`,
                                    file?.name
                                  );
                                  formikBag.setFieldValue(
                                    `fileSize`,
                                    formatFileSize(file?.size)
                                  );
                                  formikBag.setFieldValue(`fileUrl`, file);
                                  if (file) {
                                    var imageObj = await handleExcel(file);
                                    console.log(
                                      imageObj,
                                      "imageObj imageObj imageObj"
                                    );
                                    if (imageObj && imageObj.result) {
                                      // const exceObj = imageObj?.result?.map(
                                      //   (val, ind) => {
                                      //     return {
                                      //       name: val.name,
                                      //       email: val.email,
                                      //       mobileNumber:
                                      //         val.mobile?.toString(),
                                      //       department: val.department,
                                      //       mobileNumberCountryCode:
                                      //         val.mobileNumberCountryCode ||
                                      //         "+91",
                                      //       reportingManager:
                                      //         val.reportingManager,
                                      //       city: val.city,
                                      //       designation: val.designation,
                                      //       subEntity: val.subEntity,
                                      //       activate:
                                      //         val.active === 1 ? true : false,
                                      //     };
                                      //   }
                                      // );

                                      const exceObj = imageObj?.result?.map(
                                        (val, ind) => {
                                          let emailVal;
                                          if (typeof val.email === "object") {
                                            emailVal = val?.email?.text;
                                          } else {
                                            emailVal = val?.email;
                                          }
                                          return {
                                            name: val.name || "",
                                            email: emailVal || "",
                                            mobileNumber:
                                              val.mobile?.toString() || "",
                                            mobileNumberCountryCode:
                                              val.mobileNumberCountryCode ||
                                              "+91",
                                            clientLearnerId:
                                              val.clientLearnerId || "",
                                            department: val.department || "",
                                            reportingManager:
                                              val.reportingManager || "",
                                            city: val.city || "",
                                            designation: val.designation || "",
                                            subEntity: val.subEntity || "",
                                            activate:
                                              val.active === 1 ? true : false,
                                            email_dnd:
                                              val.emailTrigger,
                                          };
                                        }
                                      );
                                      e.target.value = "";
                                      console.log(exceObj, "exceObj  exceObj");
                                      formikBag.setFieldValue("data", exceObj);
                                      // formikBag.setFieldValue("isAdd", true);
                                      // formikBag.setFieldValue("isUpload", false);
                                    }
                                  }
                                }
                              }
                            }}
                            error={
                              formikBag.touched.fileUrl &&
                              formikBag.errors.fileUrl
                                ? formikBag.errors.fileUrl
                                : null
                            }
                          />
                          {/* {formikBag.values.fileName ? (
                          <UE.ButtonRow
                            themeColor={theme}
                            isBorder={true}
                          >
                            <UE.ButtonGroups themeColor={theme}>
                              <UE.CancelButton
                                themeColor={theme}
                                style={{
                                  margin: "0 0.8rem 0 0",
                                }}
                                onClick={() => {
                                  formikBag.setFieldValue(`isAdd`, true);
                                  formikBag.setFieldValue(`isUpload`, false);
                                }}
                              >
                                Cancel
                              </UE.CancelButton>
                              <UE.SaveButton
                                style={{
                                  margin: 0,
                                  fontWeight: "600",
                                }}
                                className="buttonload"
                                type="button"
                                onClick={async () => {
                                
                                }}
                              >
                                Upload
                              </UE.SaveButton>
                            </UE.ButtonGroups>
                          </UE.ButtonRow>
                        ) : (
                          ""
                        )} */}
                          {formikBag.values.fileName ? (
                            <UE.FileRow
                              themeColor={theme}
                              style={{
                                marginTop: "1rem",
                                justifyContent: "space-between",
                              }}
                            >
                              <UE.FileBox
                                themeColor={theme}
                                style={{
                                  width: "97%",
                                }}
                              >
                                <img src={csvIcon} alt="" />
                                <UE.FileContentBox themeColor={theme}>
                                  <div className="head">
                                    {formikBag.values.fileName}
                                  </div>
                                  <div className="desc">
                                    {formikBag.values.fileSize} - 100%{" "}
                                    {selectLangJson.uploaded}
                                  </div>
                                </UE.FileContentBox>
                              </UE.FileBox>
                              <UE.DelIcon
                                onClick={() => {
                                  formikBag.setFieldValue(`fileUrl`, "");
                                  formikBag.setFieldValue(`fileName`, "");
                                  formikBag.setFieldValue(`fileSize`, "");
                                }}
                              >
                                <img src={delIcon} alt="" />
                              </UE.DelIcon>
                            </UE.FileRow>
                          ) : (
                            ""
                          )}
                        </UE.FormContainer>
                      </>
                    ) : (
                      ""
                    )}
                    <LS.ButtonGroup style={{ margin: 0 }} themeColor={theme}>
                      <CDD.CancelButton
                        type="button"
                        themeColor={theme}
                        onClick={() => {
                          navigate(
                            "/client-admin/courses-manage/manage-learners"
                          );
                        }}
                      >
                        {selectLangJson.cancel}
                      </CDD.CancelButton>
                      <CDD.SaveButton
                        cursor={isLoading}
                        disabled={isLoading}
                        className="buttonload"
                        type="submit"
                      >
                        {isLoading ? (
                          <i class="fa fa-spinner fa-spin"></i>
                        ) : (
                          selectLangJson.save_changes
                        )}
                      </CDD.SaveButton>
                    </LS.ButtonGroup>
                    <PopUp
                      isOpen={warningPopUp}
                      onClose={handleClose}
                      maxWidth="400px"
                      title={
                        <>
                          <SEC.WarnIconBox>
                            <img src={warnsIcon} alt="danger" />
                          </SEC.WarnIconBox>
                        </>
                      }
                      content={
                        <>
                          <SEC.InnerSection>
                            <SEC.TitleTwo themeColor={theme}>
                              {selectLangJson?.warning}
                            </SEC.TitleTwo>
                            <SEC.Subtitle
                              style={{ textAlign: "center" }}
                              themeColor={theme}
                            >
                              {warningMessage?.message}
                            </SEC.Subtitle>
                            <UE.ButtonGroupTwo themeColor={theme}>
                              <UE.CancelButton
                                themeColor={theme}
                                style={{ width: "50%" }}
                                onClick={() => {
                                  setWarningPopUp(false);
                                }}
                              >
                                {selectLangJson?.cancel}
                              </UE.CancelButton>
                              <UE.SaveButton
                                cursor={downloadLoadingTwo}
                                disabled={downloadLoadingTwo}
                                style={{ width: "50%" }}
                                className="buttonload"
                                type="button"
                                onClick={() => {
                                  downloadCertificate(
                                    warningMessage?.excel_download_key
                                  );
                                }}
                              >
                                {downloadLoadingTwo ? (
                                  <i class="fa fa-spinner fa-spin"></i>
                                ) : (
                                  selectLangJson?.download
                                )}
                              </UE.SaveButton>
                            </UE.ButtonGroupTwo>
                            {/* <SEC.BtnClose
                            type="primary"
                            themeColor={theme}
                            onClick={() => }
                          >
                            Close
                          </SEC.BtnClose>
                          <SEC.BtnClose
                            type="primary"
                            themeColor={theme}
                            onClick={() => console.log("")}
                          >
                            
                          </SEC.BtnClose> */}
                          </SEC.InnerSection>
                        </>
                      }
                    />
                  </UE.FormContainer>
                </Form>
              )}
            </Formik>
          </LS.LearnerBox>
        </CDS.DetailInnerCon>
      </CDS.DetailCon>

      <PopUp
        isOpen={showsucessMail}
        onClose={handleClose}
        maxWidth="400px"
        title={
          <>
            <SEC.SuccessIconBoxTwo>
              <img src={theme ? successModal : successModal} alt="danger" />
            </SEC.SuccessIconBoxTwo>
          </>
        }
        content={
          <SEC.InnerSection>
            <SEC.TitleTwo themeColor={theme}>
              {selectLangJson?.great}!
            </SEC.TitleTwo>

            <SEC.Subtitle style={{ textAlign: "center" }} themeColor={theme}>
              {selectLangJson?.learner_added_successfully}.
            </SEC.Subtitle>
            <SEC.GreenContinue
              onClick={() => {
                setShowsucessMail(false);
                navigate("/client-admin/courses-manage/manage-learners");
              }}
            >
              {selectLangJson?.continue}
            </SEC.GreenContinue>
          </SEC.InnerSection>
        }
      />
    </CDS.DetailContainer>
  );
};

export default AddLearner;
